import { CalculatorIcon } from "../../assets";
import { formatNumberToLocaleString } from "../../utils/methods";
import styles from "./styles.module.scss";

interface ActivityCardProps {
  calories: number;
}

const EstimateCard: React.FC<ActivityCardProps> = ({ calories }) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.contentContainer}>
        <div className={styles.iconContainer}>
          <CalculatorIcon />
        </div>

        <p>Day Estimate: {formatNumberToLocaleString(calories)} calories</p>
      </div>
    </div>
  );
};

export default EstimateCard;
